import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

import ReviewItem from './ReviewItem';
import ReviewScore from './ReviewScore';
import ReviewMore from './ReviewMore';
import ReviewFilter from './ReviewFilter';

import { sort, filterByCountry, getTopCountries } from '~/utils/review';

class Reviews extends Component {
  static propTypes = {
    reviews: PropTypes.array,
    lxInfo: PropTypes.object,
    rating: PropTypes.number,
    categoryScore: PropTypes.object,
    withoutReview: PropTypes.number,
    trip: PropTypes.object,
    isHideHelpful: PropTypes.bool,
    user: PropTypes.object,
    url: PropTypes.object,
    userCountry: PropTypes.string,
    onReply: PropTypes.func,
    onVote: PropTypes.func,
  }

  constructor(props) {
    super(props);

    this.state = {
      reviewCount: 3,
      sortBy: 'relevance',
      selectedCountry: 'all'
    };

    this.onClickLoadMore = this.onClickLoadMore.bind(this);
    this.onChangeSort = this.onChangeSort.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.reviewCount !== this.state.reviewCount) {
      return true;
    }
    if (nextState.sortBy !== this.state.sortBy) {
      return true;
    }
    if (nextState.selectedCountry !== this.state.selectedCountry) {
      return true;
    }
    if (this.props.userCountry !== nextProps.userCountry) {
      return true;
    }
    if (this.props.galleryName !== nextProps.galleryName) {
      return true;
    }
    if (this.props.user._id !== nextProps.user._id) {
      return true;
    }
    return false;
  }

  onClickLoadMore = () => {
    const { reviews } = this.props;
    this.setState(
      state => ({
        reviewCount: state.reviewCount < reviews.length ? state.reviewCount + 3 : reviews.length
      })
    );
  }

  onChangeSort = (sortBy) => {
    this.setState({ sortBy });
  }

  onChangeCountry = (country) => {
    this.setState({
      selectedCountry: country || 'all',
    });
  }

  render() {
    const {
      trip,
      user,
      url,
      userCountry,
      isHideHelpful,
      reviews,
      rating,
      categoryScore,
      withoutReview,
      lxInfo,
    } = this.props;
    const { sortBy, selectedCountry, reviewCount } = this.state;

    const topCountries = getTopCountries(reviews, userCountry);
    const sortedReviews = sort(filterByCountry(reviews, selectedCountry), sortBy, trip._id);
    const filterReview = sortedReviews.slice(0, reviewCount);
    return (
      <Fragment>
        {/* Score */}
        <ReviewScore
          reviews={reviews}
          trip={trip}
          rating={rating}
          categoryScore={categoryScore}
          withoutReview={withoutReview}
        />
        {/* Filter */}
        <ReviewFilter
          sortBy={sortBy}
          userId={trip.user_id}
          onChangeSort={this.onChangeSort}
          onChangeCountry={this.onChangeCountry}
          selectedCountry={selectedCountry}
          topCountries={topCountries}
          userCountry={userCountry}
          reviews={reviews}
        />
        {/* Items */}
        {filterReview.map((review, index) => (
          <ReviewItem
            key={index}
            review={review}
            user={user}
            url={url}
            onVote={this.props.onVote}
            onReply={this.props.onReply}
            isHideHelpful={isHideHelpful}
          />
        ))}
        {/* More */}
        <ReviewMore
          reviews={reviews}
          lxInfo={lxInfo}
          withoutReview={withoutReview}
          onClickLoadMore={this.onClickLoadMore}
          showLoadMore={this.state.reviewCount < sortedReviews.length}
        />
      </Fragment>
    );
  }
}

export default Reviews;
